import type { CurrentRate } from '../../../../api/staff-pay-rates';
import { formatCents } from '../payFormat';

/** One of the teacher's rates: the amount and whether it's their own or the default. */
export default function MyRateValue({ rate }: { rate: CurrentRate }) {
  if (rate.amountCents === null) {
    return <span style={{ color: 'var(--nb-subtle)', fontStyle: 'italic' }}>Not set</span>;
  }
  return (
    <span>
      <span className="nb-tabular nb-mono" style={{ fontWeight: 600 }}>
        {formatCents(rate.amountCents)}
      </span>
      <span style={{ marginLeft: 6, fontSize: 11, color: 'var(--nb-subtle)' }}>
        {rate.source === 'personal' ? 'your rate' : 'default'}
      </span>
    </span>
  );
}
